/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Count } from '../models/Count';
import type { Handbook } from '../models/Handbook';
import type { HandbookCategory } from '../models/HandbookCategory';
import type { HandbookCategoryDetails } from '../models/HandbookCategoryDetails';
import type { HandbookCategoryResponseList } from '../models/HandbookCategoryResponseList';
import type { HandbookSubCategory } from '../models/HandbookSubCategory';
import { request as __request } from '../core/request';

export class HandbookService {

    /**
     * Get a category subcategory handbook
     * @returns Handbook handbook file of the category subcategory
     * @throws ApiError
     */
    public static async getHandbook({
companyId,
categoryId,
subCategoryId,
}: {
/** The companyId **/
companyId: number,
/** handbook category id **/
categoryId: number,
/** handbook subcategory id **/
subCategoryId?: number,
}): Promise<Handbook> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/handbook`,
            query: {
                'categoryId': categoryId,
                'subCategoryId': subCategoryId,
            },
        });
        return result.body;
    }

    /**
     * Archive a category subcategory handbook
     * @returns Handbook handbook file of the category subcategory
     * @throws ApiError
     */
    public static async deleteHandbook({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: Handbook,
}): Promise<Handbook> {
        const result = await __request({
            method: 'DELETE',
            path: `/companies/${companyId}/handbook`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Get a handbook count be week
     * @returns Count handbook count of the week
     * @throws ApiError
     */
    public static async getHandbookCount({
companyId,
}: {
/** The companyId **/
companyId: number,
}): Promise<Count> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/handbook/count`,
        });
        return result.body;
    }

    /**
     * Get a category along with subcategory
     * @returns HandbookCategoryResponseList list of category with subcategory
     * @throws ApiError
     */
    public static async getHandbookCategory({
companyId,
}: {
/** The companyId **/
companyId: number,
}): Promise<HandbookCategoryResponseList> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/handbook/category`,
        });
        return result.body;
    }

    /**
     * Add a handbook category
     * @returns HandbookCategory Add handbook category
     * @throws ApiError
     */
    public static async addHandbookCategory({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: HandbookCategory,
}): Promise<HandbookCategory> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/handbook/category`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Update handbook category
     * @returns HandbookCategory update handbook category
     * @throws ApiError
     */
    public static async updateHandbookCategory({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: HandbookCategory,
}): Promise<HandbookCategory> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/handbook/category`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * archive handbook category
     * @returns HandbookCategory archive handbook category
     * @throws ApiError
     */
    public static async archiveHandbookCategory({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: HandbookCategory,
}): Promise<HandbookCategory> {
        const result = await __request({
            method: 'DELETE',
            path: `/companies/${companyId}/handbook/category`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Get a category details
     * @returns HandbookCategoryDetails category details
     * @throws ApiError
     */
    public static async getHandbookCategoryDetails({
companyId,
categoryId,
}: {
/** The companyId **/
companyId: number,
/** handbook category id **/
categoryId: number,
}): Promise<HandbookCategoryDetails> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/handbook/category/details`,
            query: {
                'categoryId': categoryId,
            },
        });
        return result.body;
    }

    /**
     * Add a handbook subcategory
     * @returns HandbookSubCategory Add handbook subcategory
     * @throws ApiError
     */
    public static async addHandbookSubcategory({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: HandbookSubCategory,
}): Promise<HandbookSubCategory> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/handbook/category/subcategory`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Update handbook subcategory
     * @returns HandbookSubCategory update handbook subcategory
     * @throws ApiError
     */
    public static async updateHandbookSubcategory({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: HandbookSubCategory,
}): Promise<HandbookSubCategory> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/handbook/category/subcategory`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * archive handbook subcategory
     * @returns HandbookSubCategory archive handbook subcategory
     * @throws ApiError
     */
    public static async archiveHandbookSubcategory({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: HandbookSubCategory,
}): Promise<HandbookSubCategory> {
        const result = await __request({
            method: 'DELETE',
            path: `/companies/${companyId}/handbook/category/subcategory`,
            body: requestBody,
        });
        return result.body;
    }

}